import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { SITE, buildWhatsAppLink } from "../../lib/site";

export const FloatingCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* WhatsApp floating (all screens) */}
      <a
        href={buildWhatsAppLink("Bună ziua! Doresc detalii despre înscrierea la categoria B.")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        className="group fixed bottom-24 md:bottom-6 right-5 z-50 grid place-items-center w-14 h-14 rounded-full bg-green-500 text-white shadow-2xl hover:scale-110 transition-transform animate-float-slow animate-glow-green"
        aria-label="WhatsApp"
      >
        <span className="absolute inset-0 rounded-full bg-green-500/70 animate-ping" />
        <span className="absolute -top-1.5 -right-1.5 flex h-4 w-4">
          <span className="absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75 animate-ping" />
          <span className="relative inline-flex rounded-full h-4 w-4 bg-red-500 items-center justify-center text-[9px] font-bold">1</span>
        </span>
        <MessageCircle size={26} className="relative z-10" />
      </a>

      {/* Sticky mobile bottom bar */}
      <AnimatePresence>
        {show && (
          <motion.div
            initial={{ y: 100 }}
            animate={{ y: 0 }}
            exit={{ y: 100 }}
            transition={{ type: "spring", stiffness: 260, damping: 30 }}
            data-testid="sticky-mobile-cta"
            className="fixed bottom-0 inset-x-0 z-40 md:hidden glass-card border-t p-3 flex gap-3"
          >
            <a
              href={`tel:${SITE.phoneRaw}`}
              data-testid="sticky-call-btn"
              className="flex-1 inline-flex items-center justify-center gap-2 bg-white text-[#1565C0] border-2 border-[#1565C0] rounded-full py-3 font-semibold text-sm"
            >
              <Phone size={16} /> Sună
            </a>
            <a
              href={buildWhatsAppLink("Bună ziua! Doresc să mă înscriu la categoria B la Auto Valy Drive.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sticky-enroll-btn"
              className="flex-[1.4] inline-flex items-center justify-center gap-2 bg-[#1565C0] text-white rounded-full py-3 font-semibold text-sm"
            >
              Înscrie-te acum
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default FloatingCTA;
